import React from 'react';
import PageHero from '../components/PageHero';
import FeaturesSection from '../components/Features';
import ReportPreview from '../components/ReportPreview';
import CTASection from '../components/CTASection';
import Reveal from '../components/Reveal';

export default function Features() {
  return (
    <>
      <PageHero
        eyebrow="Features"
        title="One calm experience for your weight management journey."
        subtitle="Assessment, doctor review, plan, follow-up and AI-assisted support — connected end to end so you can stop juggling forms, clinics and reminders."
      />
      <Reveal><FeaturesSection /></Reveal>
      <Reveal><ReportPreview /></Reveal>
      <CTASection />
    </>
  );
}
